var React = require('react');

function Cruiser (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Cruiser"),React.createElement("path",{"id":"path877-4","className":"cls-1","d":"M114,69,64,19,14,69v40H114Z","key":2})]);
}

Cruiser.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Cruiser;

Cruiser.default = Cruiser;
